import { Navigate } from 'react-router-dom';

const CountryServiceConfiguration = () => (
  <Navigate to="/admin/packs-services?tab=countries" replace />
);

export { CountryServiceConfigContent } from './CountryServiceConfigContent';
export default CountryServiceConfiguration;
